<template>
  <div class="mt-1" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'EXPOAGBO',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
      <b-button
        class="btn btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea un nuovo movimento"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <template v-if="canVerb(resource, 'store')">
              <div class="inner-header--create">
                <strong class="mr-auto"> Crea un nuovo movimento </strong>
                <b-button
                  class="btn btn--create btn--smaller"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAdd"
                  title="Crea un nuovo movimento"
                  :disabled="!canVerb(resource, 'store')"
                >
                  <base-icon name="circled_plus" width="16" height="16" />
                  <span>Crea</span>
                </b-button>
              </div>
              <div class="inner-header--info">
                <strong class="mr-auto">
                  {{ computedFilterTitle }}
                </strong>
                <button class="close text-dark" @click="hide">
                  <b-icon icon="x"></b-icon>
                </button>
              </div>
            </template>
            <template v-else>
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </template>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="registrazione_da"
                label="Data registrazione da"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="registrazione_a"
                label="Data registrazione a"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="valuta_da"
                label="Data valuta da"
                v-model="filter.byEffectiveness.from"
              />
              <base-datepicker
                name="valuta_a"
                label="Data valuta a"
                v-model="filter.byEffectiveness.to"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="agencybook_type"
                label="Tipologia Movimento"
                :options="movimenti"
                v-model="filter.byAttribute.agencybook_type"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="payment_references"
                label="Causali"
                :options="opt_payment_reference"
                v-model="filter.byPaymentReference.id"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="treasuries"
                label="Comparto"
                :options="opt_sectors"
                v-model="filter.bySector.id"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="salesmen"
                label="Produttori"
                :options="salesmen_select"
                v-model="filter.byBroker.id"
                :multiple="true"
                :taggable="salesmen_taggable"
                :closeOnSelect="false"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--x-smaller btn--smaller btn--transparent"
                    @click="
                      myToggle ? selectAllSalesmen() : deselectAllSalesmen()
                    "
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
            <div class="filter-item">
              <base-select
                name="customers"
                label="Tipologia Anagrafica"
                :options="opt_customers"
                v-model="filter.attribute_type"
                @select="onSelectSuppliers"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="suppliers"
                label="Soggetto"
                :options="opt_suppliers"
                v-model="filter.byAgencyContact.id"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <agency-books-table
        @edit="onEdit"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterOn="{
          byRelations: [
            'bySector',
            'byBroker',
            'byPaymentReference',
            'byAgencyContact',
          ],
        }"
        @destroy="onDestroy"
        :ref="tableRef"
        :onlyActions="['edit', 'destroy', 'infomodal']"
      ></agency-books-table>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import AgencyBooksTable from "@/components/tables/AgencyBooks";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { mapGetters, mapActions } from "vuex";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import ExportOptions from "@/components/ExportOptions";
import BaseIcon from "@/components/BaseIcon";
import SidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, StorageGetterMixin, SidebarFilterMixin],
  props: {
    contactId: Number,
  },
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      activeFilters: {},
      filterName: "filterAgencyBook",
      resource: "agency_books",
      context: "agency_books",
      repository: "agency_book",
      tableRef: "AgencyBookTableRef",
      fields: [
        {
          key: "book_date",
          label: this.getDictionary("book_date", "agency_book"),
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "book_date",
        },
        {
          key: "effective_date",
          label: this.getDictionary("effective_date", "agency_book"),
          formatter: (value) => toLocaleDate(value),
          sortable: true,
          sortKey: "effective_date",
        },
        {
          key: "agencybook_type.text",
          label: this.getDictionary("agencybook_type", "agency_book"),
          sortable: false,
        },
        {
          key: "payment_reference.code",
          label: this.getDictionary("payment_reference_id", "agency_book"),
          sortable: true,
          sortKey: "byPaymentReference.code",
        },
        {
          key: "additional_description",
          label: this.getDictionary("additional_description", "agency_book"),
          sortable: true,
        },
        {
          key: "sector_info",
          label: this.getDictionary("title", "sector"),
          sortable: true,
          sortKey: "bySector.title",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "agency_book"),
          formatter: (value) => toLocaleCurrency(value),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "broker_info",
          label: this.getDictionary("salesman"),
          sortable: true,
          sortKey: "byBroker.BUID",
        },
        {
          key: "agency_contacts_type",
          label: this.getDictionary("Tipo Cliente"),
          sortable: false,
        },
        {
          key: "agency_contacts_SURN",
          label: this.getDictionary("attribute_CLI_value", "agency_contact"),
          sortable: true,
          sortKey: "byAgencyContact.title",
        },
        {
          key: "agency_contacts_CNAM",
          label: this.getDictionary("attribute_SUP_value", "agency_contact"),
          sortable: true,
          sortKey: "byAgencyContact.title",
        },
        {
          key: "invoice_protocol_number",
          label: this.getDictionary("invoice_protocol_number", "agency_book"),
          sortable: true,
        },
      ],
      movimenti: [
        { value: "0", text: "Versamento" },
        { value: "1", text: "Prelievo" },
        { value: "3", text: "Giroconto" },
      ],
      opt_salesmen: [],
      myToggle: false,
      myTogglePO: false,
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      opt_customers: [
        { text: "Cliente", value: "Y" },
        { text: "Fornitore", value: "N" },
      ],
      opt_suppliers: [],
      opt_sectors: [],
      opt_payment_reference: [],
    };
  },
  components: {
    BaseIcon,
    BaseSelect,
    BaseDatepicker,
    AgencyBooksTable,
    ExportOptions,
    // ButtonGroupTable,
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computeActiveFilters() {
      return this.retriveActiveFilters();
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  methods: {
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllSalesmen() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllSalesmen() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    initFilter() {
      let init = {
        byAttribute: {
          agencybook_type: null,
          gross: null,
          salesman_id: null,
          cod_causale: null,
        },
        byCalendar: {
          from: null,
          to: null,
        },
        byEffectiveness: {
          from: null,
          to: null,
        },
        bySector: {
          id: null,
        },
        byBroker: {
          id: null,
        },
        byPaymentReference: {
          id: null,
        },
        byAgencyContact: {
          id: null,
          SUP: null,
          CLI: null,
        },
        attribute_type: null,
      };
      return init;
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      this.activeFilters = {};
      this.exportUrl = null;
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id, item) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}`, item: item },
      });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Movimento Eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSelectSuppliers() {
      const Repo = RepositoryFactory.get("agency_contact");
      let qs = null;
      if (this.filter.attribute_type == "Y") {
        qs = "byAttribute[CLI]=Y";
        this.filter.byAgencyContact.CLI = "Y";
        this.filter.byAgencyContact.SUP = null;
      } else {
        qs = "byAttribute[SUP]=Y";
        this.filter.byAgencyContact.CLI = null;
        this.filter.byAgencyContact.SUP = "Y";
      }
      Repo.index(qs)
        .then((response) => {
          this.opt_suppliers = response.data.data.map((supplier) => {
            return { value: supplier.id, text: supplier.formatted_title };
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      delete this.activeFilters["byAgencyContact.CLI"];
      delete this.activeFilters["byAgencyContact.SUP"];

      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    ...mapGetters("auth", {
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getPaymentReferences: "payment_references",
      getSectors: "sectors",
    }),
  },
  created() {
    /* */
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("payment_references"))
      resources.push(
        this.$store
          .dispatch(`${path}payment_references`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.opt_payment_reference = this.getPaymentReferences();
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    } else {
      // this.getReports();
      this.opt_payment_reference = this.getPaymentReferences();
      this.isLoading = false;
    }
    /* */
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
  },
  mounted() {
    this.opt_salesmen = this.getSalesmen();
    this.opt_sectors = this.getSectors().filter(
      (sector) => sector.is_agency === "Y",
    );
    // this.opt_payment_reference = this.getPaymentReferences();
  },
};
</script>
